"use strict";
import i from "./index.es99.js";
import a from "./index.es100.js";
import e from "./index.es101.js";
import n from "./index.es102.js";
import l from "./index.es103.js";
import s from "./index.es104.js";
import u from "./index.es105.js";
import c from "./index.es106.js";
import d from "./index.es107.js";
import { VERSION as C } from "./index.es108.js";
import x from "./index.es109.js";
import A from "./index.es110.js";
import E from "./index.es111.js";
import y from "./index.es112.js";
import O from "./index.es113.js";
import g from "./index.es114.js";
import w from "./index.es115.js";
function p(o) {
  const m = new e(o), t = a(e.prototype.request, m);
  return i.extend(t, e.prototype, m, { allOwnKeys: !0 }), i.extend(t, m, null, { allOwnKeys: !0 }), t.create = function(f) {
    return p(n(o, f));
  }, t;
}
const r = p(l);
r.Axios = e;
r.CanceledError = u;
r.CancelToken = c;
r.isCancel = d;
r.VERSION = C;
r.toFormData = x;
r.AxiosError = A;
r.Cancel = r.CanceledError;
r.all = function(o) {
  return Promise.all(o);
};
r.spread = E;
r.isAxiosError = y;
r.mergeConfig = n;
r.AxiosHeaders = O;
r.formToJSON = (o) => s(i.isHTMLForm(o) ? new FormData(o) : o);
r.getAdapter = g.getAdapter;
r.HttpStatusCode = w;
r.default = r;
export {
  r as default
};
//# sourceMappingURL=index.es28.js.map
